<template>
	<span class="h-1 bg-gray-200 block mb-2">
		<span
			class="h-1 bg-primary block transform origin-left transition-transform duration-500 scale-100"
			:style="`--tw-scale-x: ${progress}%`"
		></span>
	</span>
</template>

<script lang="ts" setup>
export interface Props {
  progress: number
}

defineProps<Props>();
</script>
